import React from 'react';
import ToastRoot from '../toast/toast-root';
import PreviewBlocker from '../preview-blocker/preview-blocker';
import ModalRoot from '../modals/modal-root';
import { getIsMobile, getIsPreview, getIsEditor, } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../context/api-context/use-api';
const OverlayLayerContainer = () => {
    const { isMobile, isPreview, isEditor } = useApi((state) => ({
        isMobile: getIsMobile(state),
        isPreview: getIsPreview(state),
        isEditor: getIsEditor(state),
    }));
    return (React.createElement(React.Fragment, null,
        (isPreview || isEditor) && React.createElement(PreviewBlocker, { isMobile: isMobile }),
        React.createElement(ModalRoot, null),
        React.createElement(ToastRoot, null)));
};
export default OverlayLayerContainer;
//# sourceMappingURL=overlay-layer-container.js.map